import { NgModule } from '@angular/core';
import { GriffieConfigurationComponent } from './components/griffie-configuration/griffie-configuration.component';
import { PluginTranslatePipeModule } from '@valtimo/plugin';
import { CommonModule } from '@angular/common';
import {
  ButtonModule as CarbonButtonModule,
  InputModule as CarbonInputModule,
  ModalModule,
} from 'carbon-components-angular';
import {
  CarbonMultiInputModule,
  // ValtimoCdsModalDirectiveModule,
  // ButtonModule,
  FormModule,
  InputLabelModule,
  InputModule,
  MultiInputFormModule,
  ParagraphModule,
  RadioModule,
  SelectModule,
  TooltipIconModule,
} from '@valtimo/components';

@NgModule({
  declarations: [GriffieConfigurationComponent],
  imports: [
    CommonModule,
    PluginTranslatePipeModule,
    FormModule,
    InputModule,
    SelectModule,
    ParagraphModule,
    MultiInputFormModule,
    RadioModule,
    InputLabelModule,
    // ButtonModule,
    ModalModule,
    CarbonInputModule,
    TooltipIconModule,
    CarbonMultiInputModule,
    CarbonButtonModule,
    // ValtimoCdsModalDirectiveModule,
  ],
  exports: [GriffieConfigurationComponent],
})
export class GriffiePluginModule { }
